(function() {
    'use strict';

    angular.module('settings')
        .controller('SettingListController', SettingListController);

    SettingListController.$inject = ['$state', 'settingDataSrvc', 'settingSrvc', 'notificationSrvc', 'settingMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'searchFilterSrvc', 'checkSearchSrvc', 'settingPermissionsConst', 'filterQuerySrvc'];

    function SettingListController($state, settingDataSrvc, settingSrvc, notificationSrvc, settingMessagesConst, lodashService, datatableDefaultPageSizeValueConst, searchFilterSrvc, checkSearchSrvc, settingPermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.settingRows = [];
        self.settingCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Wartość',
            value: 'value',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opis',
            value: 'description',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.modelPermissions = settingPermissionsConst;
        self.searchQuery = {
            name: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getSettings();
        }

        function getSettings(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering
                };
            }
            return settingDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.settingRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getSettings);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.setting.create');
        }

        function onEdit(row) {
            $state.go('layout.setting.update', { pk: row.pk });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getSettings();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getSettings();
        }
    }
})();
